import { Injectable } from '@angular/core';
import {HttpProvider} from "../../providers/http/http";

@Injectable()
export class RobotService {

  constructor(private http: HttpProvider) { }

  getRobotList(){
    return this.http.hPost('/robot/get_list');
  }

  modifyRobot(params){
    return this.http.hPost('/robot/modify', params);
  }
}



// WEBPACK FOOTER //
// ./src/pages/robot/robot.service.ts